module.exports = __webpack_public_path__ + "static/media/top_catch_sub.534b43a5.png";